import R from 'app/assets/R'
import { BaseLayoutReport } from 'app/components/common/BaseLayoutReport'
import { data } from './data'
import { useTranslation } from 'react-i18next'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { useEffect } from 'react'
import { ModulePermissionEnum } from 'app/common/permission-module'

const AccountingContainer = () => {
  const { t } = useTranslation()

  const { isHavePermissionAndGoBack } = useVerifyPermissionAndRedirect()

  useEffect(() => {
    isHavePermissionAndGoBack(
      ModulePermissionEnum.ACCOUNTING,
      R.strings.accounting,
    )
  }, [t])

  return (
    <BaseLayoutReport
      data={data}
      titleI18nKey={R.strings.accounting}
      modulePermission={ModulePermissionEnum.ACCOUNTING}
    />
  )
}

export default AccountingContainer
